export class TimeClockModel { 
    timeclock_seq: number
    employee_no: number   
    employee_name: string   
    time_stamp: string 
    in_out: boolean 
    modifier: string 

    constructor( 
        timeclock_seq: number,
        employee_no: number,
        employee_name: string,
        time_stamp: string, 
        in_out: boolean ,
        modifier: string  
    ) { 
        this.timeclock_seq = timeclock_seq
        this.employee_no = employee_no
        this.employee_name = employee_name
        this.time_stamp = time_stamp
        this.in_out = in_out
        this.modifier = modifier
         
    } 
}